import { UserActionCreatorService } from './services/user-action-creator.service';
import { UserRequester, UserService } from './services/user.service';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { UserCounterWarningComponent } from './components/user-counter-warning/user-counter-warning.component';
import { UserCounterTableComponent } from './components/user-counter-warning/user-counter-table/user-counter-table.component';
import { UserMergeNotificationModalComponent } from './components/user-merged-notification/user-merge-notification-modal.component';
import { PatientEditingComponent } from './components/patient-editing/patient-editing.component';
import { PatientInfoService } from './services/patientInfo.service';
import { ClinicalTrialService } from './services/clinical-trial.service';
import {AuthenticationService} from "@ispm/user/services/authentication.service";
import {NotesService} from "@ispm/user/services/notes.service";

export const USER_COMPONENTS = [
  UserProfileComponent,
  UserCounterWarningComponent,
  UserCounterTableComponent,
  PatientEditingComponent,
  UserMergeNotificationModalComponent
];

export const USER_SERVICES = [
  UserActionCreatorService,
  UserRequester,
  UserService,
  PatientInfoService,
  ClinicalTrialService,
  AuthenticationService,
  NotesService
];
